import { useMemo } from 'react';
import { createTheme, ThemeProvider } from '@mui/material';

import { useDarkMode } from '../lib/darkMode';

import { Routes } from './Routes';

export function App() {
  const darkMode = useDarkMode();

  const theme = useMemo(() => createTheme({
    palette: {
      mode: darkMode ? `dark` : `light`,
      // Match the Tailwind dark grays (navy) instead of MUI's near-black default
      ...(darkMode && {
        background: {
          default: `#111827`,
          paper: `#1f2937`,
        },
        divider: `#374151`,
      }),
    },
  }), [darkMode]);

  return (
    <ThemeProvider theme={ theme }>
      <Routes/>
    </ThemeProvider>
  );
}
